import React, { useEffect, useState } from "react";
import { StyleSheet, css } from "aphrodite";
import ProductPage from "../products/product_page";
import {writeProductToDB, updateProductFromDB} from "../../../services/firebase"

export default function ProductInfo({ mainImage, title,
    productTpe, description, secondImage, firstMiniTitle,
    fisrtMiniDescription, thirdImage, secondMiniDescription,
    secondMiniTitle, specs, otherImages, url, uid=false
}){

    const [blogContent, setBlogContent] = useState({
        mainImage:mainImage,
        title:title,
        productTpe:productTpe,
        description:description,
        secondImage: secondImage,
        firstMiniTitle: firstMiniTitle,
        fisrtMiniDescription: fisrtMiniDescription,
        thirdImage: thirdImage,
        secondMiniDescription: secondMiniDescription,
        secondMiniTitle: secondMiniTitle,
        specs: specs,
        otherImages: otherImages,
        url: url
    });
    const isEmpty = (field) => {
        return (field+'').trim().length === 0
    }

    const convertToBase = (file, callback = () => {}) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            callback(reader.result, null);
        };
        reader.onerror = function (err) {
            callback(null, err);
        };  
    }
    
    const clearBlogContent = () => {
        
        setBlogContent({
            mainImage:'',
            title:'',
            productTpe:'',
            description:'',
            secondImage: '',
            firstMiniTitle: '',
            fisrtMiniDescription:'',
            thirdImage: '',
            secondMiniDescription:'',
            secondMiniTitle: '',
            specs: '',
            otherImages:'',
            url: ''
        });
    }

    const fileChangeHandler = async (event) => {
        let file = event.target.files[0];
        
        convertToBase(file, (res, err) => {
            if(err) {
                return;
            }

            setBlogContent((prev) => ({...prev, mainImage:res}));
        });

    }
    const seondFileChangeHandler = async (event) => {
        let file = event.target.files[0];
        
        convertToBase(file, (res, err) => {
            if(err) {
                return;
            }

            setBlogContent((prev) => ({...prev, secondImage:res}));
        });

    }
    const thirdFileChangeHandler = async (event) => {
        let file = event.target.files[0];
        
        convertToBase(file, (res, err) => {
            if(err) {
                return;
            }

            setBlogContent((prev) => ({...prev, thirdImage:res}));
        });

    }
    const fourthFileChangeHandler = async (event) => {
        let files = event.target.files
        console.log(files)
        for(let i = 0; i < files.length; i++ ){
            console.log(files[i])
            convertToBase(files[i], (res, err) => {
                if(err) {
                    return;
                }
    
                setBlogContent((prev) => ({...prev, otherImages:[ res ]}));
            });
        }

    }
    const handlePublish = () => {
        let item = {...blogContent}
        if(isEmpty(item.mainImage)) {
            alert('invald main image')
            return;
        }
        if(isEmpty(item.title)) {
            alert('invalid title')
            return;
        }
        if(isEmpty(item.productTpe)) {
            alert('Invalid product type')
            return;
        }
        if(isEmpty(item.description)) {
            alert('Invalid description')
            return;
        }
        if(isEmpty(item.secondImage)) {
            alert('Invalid second image')
            return;
        }
        if(isEmpty(item.firstMiniTitle)) {
            alert('Invalid first mini title')
            return;
        }
        if(isEmpty(item.fisrtMiniDescription)) {
            alert('Invalid first mini description')
            return;
        }
        if(isEmpty(item.thirdImage)) {
            alert('Invalid third image')
            return;
        }
        if(isEmpty(item.secondMiniDescription)) {
            alert('Invalid second mini description')
            return;
        }
        if(isEmpty(item.secondMiniTitle)) {
            alert('Invalid second mini title')
            return;
        }
        if(isEmpty(item.specs)) {
            alert('Invalid specs')
            return;
        }else{
            let specsArray = item.specs
            if(!specsArray[0].includes("-"))
                specsArray = specsArray.map((spec)=>{
                    let modifiedSpec = spec.trim()
                    return modifiedSpec = "-"+ modifiedSpec
                })
            console.log('specs: ' + specsArray)
            item.specs = specsArray
        }
        if(isEmpty(item.otherImages)) {
            alert('Invalid other images')
            return;
        }
        if(isEmpty(item.url)) {
            alert('Invalid url')
            return;
        }else{
            if(uid === false)
                item.url = "/products/"+item.url
        }

        console.log('blog', item);
        if(uid === false)
            writeProductToDB(item)
        else
            updateProductFromDB(uid, item)
        clearBlogContent();
        alert("Product posted")
    }

    const styles = StyleSheet.create({
        container: {
            backgroundColor: '#F0EFEC',
            display: "flex",
            flexDirection:'column',
            gap:'1rem',
            padding:'10px',
            margin: "2% 2% 3%",
            borderRadius:'10px',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                gap:'0rem',
                flexDirection:'row',
            }
        },
        firstContainer: {
            width:'100%',
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "left",
            
        },
        secondContainer: {
            position:'relative',
            display: "flex",
            padding:'0.5rem',
            flexDirection: "column",
            gap: "50px",
            alignItems: "left",
            border:'1px solid grey',
            borderRadius: "6px",
            pointerEvents:'none',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                width:'100%',
                padding:"1rem 1rem 0rem 1rem",
            }
        },
        htmlEditor: {
            height: "30rem", 
            backgroundColor:'red',
            /*tablet and bigger screens*/
            marginBottom: "5rem",
            "@media (min-width: 1024px)": {
                marginBottom: "4rem",
                maxWidth: "45vw",  
                height: "20rem", 
                
            }
        },
        titles: {
            color: "#011a39",
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "1.5rem",
        },
        inputContainer: {
            gridColumnStart: "3",
            height: "30px",
            fontSize: "18px",
            border: "none",
            borderBottom: "1px solid grey",
            color: "grey",
            textAlign: "left",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                width: "94%",
                
            }
        },
        inputImage: {
            display:'none',
        },
        fileButton: {
            borderRadius: "6px",
            width:'100%',
            height: "40px",
            cursor: "pointer",
            transition:'0.3s',
            backgroundColor: '#fec803',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "15px",
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                width: "100px",
                ":hover": {
                    backgroundColor:'#011a39',
                    border:'#011a39 solid 1px',
                    color:"white",
                }
            }
        },
        uploadButton: {
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize: "20px",
            marginTop: "20px",
            border: "none 1px grey",
            borderRadius: "6px",
            height: "60px",
            width:'100%',
            cursor: "pointer",
            transition:'0.3s',
            backgroundColor: '#fec803',
            /*tablet and bigger screens*/
            "@media (min-width: 1024px)": {
                
                width: "200px",
                ":hover": {
                    backgroundColor:'#011a39',
                    color:"white",
                },
            }
        },
        buttons: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-evenly",
        },
        testContainer: {
            maxWidth:'800px',
            width:'100%',
            overflow:'hidden'
        },
        previewTitle:{
            position:'absolute',
            transform:'rotate(45deg)',
            left:'calc((100% / 2) - 5rem)',
            top:'calc(100% / 2)',
            fontFamily:'Montserrat',
            fontSize:'2rem',
            color:'red',
            opacity:"0.5"
        },
        googleContainer:{
            width:'100%',
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
        },
        optionsContainerStyle:{
            display:'flex',
            flexDirection: 'column',
            //backgroundColor:'red',
            justifyContent: 'center',
            fontFamily: 'Oswald',
            fontStyle: "bold",
            fontSize:'2rem',
            gap: "10px",
            alignItems: "center",
        }
    });
   

    return(
        <div className={css(styles.container)}>
        <div className={css(styles.firstContainer)}>

            <div className={css(styles.firstContainer)}>
               <span className={css(styles.titles)}>MAIN IMAGE:</span> 
            <div>
                <input type="file" onChange={fileChangeHandler} id="fileInput" className={css(styles.inputImage)}/>
                <button className={css(styles.fileButton)} onClick={() => document.getElementById('fileInput').click()}>Select image</button>
            </div>
            </div>

            <span className={css(styles.titles)}> TITLE: </span>
            <input value={blogContent.title} onChange={(e) => {setBlogContent((prev) => ({...prev, title: e.target.value}))}} className={css(styles.inputContainer)}></input>
            
            <span className={css(styles.titles)}>PRODUCT TYPE: </span>
            <input value={blogContent.productTpe} onChange={(e) => setBlogContent((prev) => ({...prev, productTpe: e.target.value}))} className={css(styles.inputContainer)}></input>
            
            <span className={css(styles.titles)}>DESCRIPTION: </span>
            <input value={blogContent.description} onChange={(e) => setBlogContent((prev) => ({...prev, description: e.target.value}))} className={css(styles.inputContainer)}></input>
            
            <div className={css(styles.firstContainer)}>
               <span className={css(styles.titles)}>SECOND IMAGE:</span> 
            <div>
                <input type="file" onChange={seondFileChangeHandler} id="secondFileInput" className={css(styles.inputImage)}/>
                <button className={css(styles.fileButton)} onClick={() => document.getElementById('secondFileInput').click()}>Select image</button>
            </div>
            </div>

            <span className={css(styles.titles)}>FIRST MINI TITLE: </span>
            <input value={blogContent.firstMiniTitle} onChange={(e) => setBlogContent((prev) => ({...prev, firstMiniTitle: e.target.value}))} className={css(styles.inputContainer)}></input>

            <span className={css(styles.titles)}>FIRST MINI DESCRIPTION: </span>
            <input value={blogContent.fisrtMiniDescription} onChange={(e) => setBlogContent((prev) => ({...prev, fisrtMiniDescription: e.target.value}))} className={css(styles.inputContainer)}></input>
            
            <div className={css(styles.firstContainer)}>
                <span className={css(styles.titles)}>THIRD IMAGE:</span> 
            <div>
                <input type="file" onChange={thirdFileChangeHandler} id="thirdFileInput" className={css(styles.inputImage)}/>
                <button className={css(styles.fileButton)} onClick={() => document.getElementById('thirdFileInput').click()}>Select image</button>
            </div>
            </div>

            <span className={css(styles.titles)}>SECOND MINI DESCRIPTION: </span>
            <input value={blogContent.secondMiniDescription} onChange={(e) => setBlogContent((prev) => ({...prev, secondMiniDescription: e.target.value}))} className={css(styles.inputContainer)}></input>

            <span className={css(styles.titles)}>SECOND MINI TITLE: </span>
            <input value={blogContent.secondMiniTitle} onChange={(e) => setBlogContent((prev) => ({...prev, secondMiniTitle: e.target.value}))} className={css(styles.inputContainer)}></input>

            <span className={css(styles.titles)}>SPECS: </span>
            <span className={css(styles.titles)}>(Incluir coma para separar cada spec)</span>
            <input value={blogContent.specs} onChange={(e) => setBlogContent((prev) => ({...prev, specs: e.target.value.split(',')}))} className={css(styles.inputContainer)}></input>

            <div className={css(styles.firstContainer)}>
                <span className={css(styles.titles)}>OTHER IMAGES:</span> 
                <span className={css(styles.titles)}>(Imagenes de galeria)</span> 
            <div>
                <input  multiple type="file" onChange={fourthFileChangeHandler} id="fourthFileInput" className={css(styles.inputImage)}/>
                <button className={css(styles.fileButton)} onClick={() => document.getElementById('fourthFileInput').click()}>Select images</button>
            </div>
            </div>

            <span className={css(styles.titles)}>URL: </span>
            <span className={css(styles.titles)}>Estara dentro de la liga "/products/"</span>
            <input value={blogContent.url} onChange={(e) => setBlogContent((prev) => ({...prev, url: e.target.value}))} className={css(styles.inputContainer)}></input>

            <div className={css(styles.buttons)}>
                <button className={css(styles.uploadButton)} onClick={() => clearBlogContent()}>CLEAR</button>
            </div>
            <div className={css(styles.buttons)}>
                <button className={css(styles.uploadButton)} onClick={() => handlePublish()}>PUBLISH</button>
            </div>
            </div>
            <div className={css(styles.secondContainer)}>
                <span className={css(styles.previewTitle)}>PREVIEW</span>
                <ProductPage 
                    mainImage={blogContent.mainImage} 
                    title={blogContent.title} 
                    productTpe={blogContent.productTpe} 
                    description={blogContent.description} 
                    secondImage={blogContent.secondImage} 
                    firstMiniTitle={blogContent.firstMiniTitle} 
                    fisrtMiniDescription={blogContent.fisrtMiniDescription} 
                    thirdImage={blogContent.thirdImage} 
                    secondMiniDescription={blogContent.secondMiniDescription} 
                    secondMiniTitle={blogContent.secondMiniTitle} 
                    getProductInfo={false}>
                </ProductPage>
            </div>
        </div>
    )
}